import React from "react";
import "./TheParentDashboard.css";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

export default function AvailablePapers({ availablePapers, parent_dashboard_initial_loading, parent_dashboard_data_loading }) {
  return (
    <div className="available-papers-wrapper mt-4 p-3">
      <div className="available-header mb-3">
        <div className="available-tab-title">Latest Available Papers</div>
      </div>

      <div className="available-paper-list">
        {!parent_dashboard_initial_loading && !parent_dashboard_data_loading && availablePapers && availablePapers?.length > 0 ? (

          availablePapers?.map((item, index) => (
            <div className="exam-row d-flex align-items-center available-paper-row" key={index}>
              <div className="exam-icon" aria-hidden="true">
                <DescriptionOutlinedIcon fontSize="small" />
              </div>
              <div className="available-paper-info d-flex flex-column flex-grow-1">
                <span className="exam-text">{item?.assess_name || "N/A"}</span>
                <div className="subject-info d-flex align-items-center gap-2">
                  <span className="subject-name">{item?.subject_name || "N/A"}</span>
                  <span className="subject-medium">{item?.language_name || "N/A"}</span>
                </div>
              </div>
              <div className="grade-pill ms-auto">Grade {item?.grade_name || "N/A"}</div>
            </div>
          ))

        ) : (
          parent_dashboard_initial_loading || parent_dashboard_data_loading ? (
            <div >Loading...</div>
          ) : (
            <div >No Papers</div>
          )

        )}
      </div>
    </div>
  );
}
